var exports = {
  "u": "x804f0401--ff8397--spinner",
};

module.exports = exports;
